
// import axios from "../utils/axios";
// import API from "../api/api";

// export const applyCoupon = async ({
//     code,
//     cart,
//     shippingMethodId,
// }) => {

//   console.log("Coupon cart Service",cart);

//   console.log("Coupon cart Service length",cart.length);
// console.log("Coupon cart", Array.isArray(cart), cart);


//     const items = (cart || [])
//         .map((item) => {       

//             const variationId =
//                 item?.selectedVariation?.variationId  ;
//               //  item?.variation_id ??
//                // item?.variationId;

//             const quantity = Number(
//             //    item?.quantity ??
//                 item?.qty ?? 1
//              //   item?.count ??
//                // 1
//             );

//             return {
//                 variation_id: Number(variationId),
//                 quantity,
//             };
//         })
//         .filter(
//             (item) =>
//                 Number.isInteger(item.variation_id)
//                 &&
//                 item.variation_id > 0
//                 &&
//                 item.quantity > 0
//         );

//     if (!items.length) {
//         throw new Error(
//             "سبد خرید خالی است یا تنوع کالا معتبر نیست."
//         );
//     }

//     if (!shippingMethodId) {
//         throw new Error(
//             "روش ارسال انتخاب نشده است."
//         );
//     }

//     console.log("Coupon cart items", Array.isArray(items), items);

//     const response = await axios.post(
//         `${API}/checkout/apply-coupon`,
//         {
//             code: String(code).trim(),

//             shipping_method_id:
//                 Number(shippingMethodId),

//             items,
//         }
//     );

//     return response.data;
// };

import api from "../utils/axios";

export const getCartItemsForCoupon = (cart = []) => {

    return cart.map((item, index) => {

        /*
        |--------------------------------------------------------------------------
        | Your cart can store variation in different places.
        |--------------------------------------------------------------------------
        */

        const variationId =
            // item?.selectedVariation?.id ??
            // item?.selectedVariation?.variation_id ??
            // item?.variation_id ??
            item?.selectedVariation.variationId ??
          //  item?.variation?.id ??
            null;

        const quantity = Number(
         //   item?.quantity ??
            item?.qty ??
           // item?.count ??
            1
        );

        return {
            index,
            productId:
                item?.id ??
                item?.product_id ??
                item?.productId ??
                null,

            variationId:
                variationId !== null
                    ? Number(variationId)
                    : null,

            quantity,

            productName:
                item?.name ??
                item?.product?.name ??
                `Product ${index + 1}`,
        };
    });
};


export const applyCoupon = async ({
    code,
    cart,
    shippingMethodId,
}) => {

    const normalizedCode =
        String(code ?? "").trim();

    if (!normalizedCode) {

        throw new Error(
            "Coupon code is required."
        );
    }

    if (!cart?.length) {

        throw new Error(
            "سبد خرید خالی است."
        );
    }

    if (!shippingMethodId) {

        throw new Error(
            "روش ارسال انتخاب نشده است."
        );
    }

    /*
    |--------------------------------------------------------------------------
    | Normalize cart
    |--------------------------------------------------------------------------
    */

    const normalizedCart =
        getCartItemsForCoupon(cart);

    /*
    |--------------------------------------------------------------------------
    | Debug
    |--------------------------------------------------------------------------
    */

    console.log(
        "Cart before coupon:",
        cart
    );

    console.log(
        "Normalized coupon items:",
        normalizedCart
    );

    /*
    |--------------------------------------------------------------------------
    | Make sure every item has a variation ID
    |--------------------------------------------------------------------------
    */

    const invalidItems =
        normalizedCart.filter(
            (item) =>
                !item.variationId ||
                !Number.isInteger(
                    item.variationId
                ) ||
                item.variationId <= 0 ||
                !Number.isInteger(
                    item.quantity
                ) ||
                item.quantity <= 0
        );

    if (invalidItems.length) {

        console.error(
            "Invalid coupon cart items:",
            invalidItems
        );

        throw new Error(
            "یکی از کالاهای سبد خرید تنوع معتبر ندارد."
        );
    }

    /*
    |--------------------------------------------------------------------------
    | Payload
    |--------------------------------------------------------------------------
    */

    const payload = {

        code: normalizedCode,

        shipping_method_id:
            Number(shippingMethodId),

        items:
            normalizedCart.map(
                (item) => ({
                    variation_id:
                        item.variationId,

                    quantity:
                        item.quantity,
                })
            ),

    };

    console.log(
        "Coupon request payload:",
        payload
    );

    const response =
        await api.post(
            "/checkout/apply-coupon",
            payload
        );

    return response.data;
};